module.exports = __webpack_public_path__ + "img/compact-disc.926a2a8d.svg";